// import React, { useEffect } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import {
//   MenuItem,
//   Select,
//   Box,
//   Button,
//   Grid,
//   InputLabel,
//   Pagination,
//   IconButton,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import SearchImg from '../../assets/search.svg';
// import Expenses from './Expenses';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import BigFilter from 'src/components/inputs/BigFilter';
// import ClearIcon from '@mui/icons-material/Close';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setAllExpenses,
//   setFilters,
//   setCurrentPage,
//   setPagination,
//   resetFilters,
//   setLoading,
//   setError,
//   setExpenseTypes,
// } from 'src/redux/slices/expenseSlice';

// const filterModeOfPayment = [
//   { label: 'Cash', value: 'Cash' },
//   { label: 'Credit/Debit Card', value: 'Credit/Debit Card' },
//   { label: 'Paytm', value: 'Paytm' },
//   { label: 'PhonePe', value: 'PhonePe' },
//   { label: 'Gpay', value: 'Gpay' },
// ];

// const AllExpenses = () => {
//   const { fetchAllExpenses, activeBranchId, fetchAllExpenseType } = useMain();
//   const dispatch = useDispatch();
//   const {
//     expenses,
//     filteredExpenses,
//     displayedExpenses,
//     expenseTypes,
//     filters,
//     pagination,
//     loading,
//     error,
//   } = useSelector((state) => state.expenses);

//   const getData = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await fetchAllExpenses(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setAllExpenses(res?.data));
//       }
//     } catch (error) {
//       dispatch(setError(error.message));
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       getData();
//       fetchAllExpenseType(activeBranchId).then((res) => {
//         if (res.statusCode === 200) {
//           const types = [
//             { label: 'Salary' },
//             { label: 'Staff Advance' },
//             ...res.data.map((t) => ({ label: t })),
//             { label: 'Others' },
//           ];
//           dispatch(setExpenseTypes(types));
//           dispatch(resetFilters());
//         }
//       });
//     }
//   }, [activeBranchId]);

//   const handleLimitChange = (e) => {
//     dispatch(setPagination({ itemsPerPage: e.target.value, currentPage: 1 }));
//   };

//   const handlePageChange = (e, value) => {
//     dispatch(setCurrentPage(value));
//   };

//   const groupedOptions = [
//     {
//       title: 'Mode of Payment',
//       items: filterModeOfPayment,
//     },
//     {
//       title: 'Type of Expense',
//       items: expenseTypes.map((type) => ({ label: type.label, value: type.label })),
//     },
//   ];

//   return (
//    <PageContainer title="All Expenses" description="This contains all expenses">
//   <DashboardCard2 title="All Expenses">
//     <div
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-end',
//         marginBottom: '1.7rem',
//       }}
//     >
//       {/* Left Side: Show per page */}
//       <div>
//         <InputLabel>Show per page</InputLabel>
//         <Select
//           value={pagination.itemsPerPage}
//           onChange={handleLimitChange}
//           style={{
//             borderRadius: '7px',
//             border: '0.5px solid #6174DD',
//             padding: '4px 12px',
//             background: '#FFF',
//             height: '40px',
//             width: '100px',
//           }}
//         >
//           <MenuItem value={10}>10</MenuItem>
//           <MenuItem value={20}>20</MenuItem>
//           <MenuItem value={50}>50</MenuItem>
//            <MenuItem value={1000000}>All</MenuItem>
//         </Select>
//       </div>

//       {/* Right Side: Search and Filter with 0.8rem gap (Search first, then Filter) */}
//       <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.8rem' }}>
//         {/* Search */}
//         <div>
//           <InputLabel>Search</InputLabel>
//           <div className="search-input">
//             <img src={SearchImg} alt="" />
//             <input
//               placeholder='Search expenses...'
//               value={filters.search}
//               onChange={(e) => dispatch(setFilters({ search: e.target.value }))}
//             />
//             {filters.search && (
//               <IconButton onClick={() => dispatch(setFilters({ search: '' }))}>
//                 <ClearIcon />
//               </IconButton>
//             )}
//           </div>
//         </div>

//         {/* Filter */}
//         <div style={{ marginTop: '27px' }}>
//           <BigFilter
//             options={groupedOptions}
//             value={filters.filterSelection}
//             onChange={(newValues) => dispatch(setFilters({ filterSelection: newValues }))}
//             placeholder="Filters"
//           />
//         </div>
//       </div>
//     </div>

//     {loading ? (
//       <ShowLoader />
//     ) : filteredExpenses.length > 0 ? (
//       <>
//         <Grid container spacing={3}>
//           <Grid item xs={12} lg={12}>
//             <Expenses data={displayedExpenses} getExpenses={getData} />
//           </Grid>
//         </Grid>
//         <Box display="flex" justifyContent="end" marginTop="20px">
//           <Pagination
//             count={pagination.totalPages}
//             page={pagination.currentPage}
//             onChange={handlePageChange}
//             color="primary"
//           />
//         </Box>
//       </>
//     ) : (
//       <Box>No expenses found.</Box>
//     )}
//   </DashboardCard2>
// </PageContainer>
//   );
// };

// export default AllExpenses;
import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import {
  MenuItem,
  Select,
  Box,
  Button,
  Grid,
  InputLabel,
  Pagination,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import Expenses from './Expenses';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import BigFilter from 'src/components/inputs/BigFilter';
import ClearIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAllExpenses,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
  setLoading,
  setError,
  setExpenseTypes,
} from 'src/redux/slices/expenseSlice';
import * as XLSX from 'xlsx';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import BulkUploadExpenseDialog from './components/BulkUploadExpenseDialog'; 

const filterModeOfPayment = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Credit/Debit Card', value: 'Credit/Debit Card' },
  { label: 'Paytm', value: 'Paytm' },
  { label: 'PhonePe', value: 'PhonePe' },
  { label: 'Gpay', value: 'Gpay' },
];

const AllExpenses = () => {
  const { fetchAllExpenses, activeBranchId, fetchAllExpenseType, createManyExpense, setShowMessage } = useMain();
  const dispatch = useDispatch();
  const {
    expenses,
    filteredExpenses,
    displayedExpenses,
    expenseTypes,
    filters,
    pagination,
    loading,
    error,
  } = useSelector((state) => state.expenses);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setUploadedData(null);
  };

  const getData = async () => {
    try {
      dispatch(setLoading(true));
      const res = await fetchAllExpenses(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllExpenses(res?.data));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      getData();
      fetchAllExpenseType(activeBranchId).then((res) => {
        if (res.statusCode === 200) {
          const types = [
            { label: 'Salary' },
            { label: 'Staff Advance' },
            ...res.data.map((t) => ({ label: t })),
            { label: 'Others' },
          ];
          dispatch(setExpenseTypes(types));
          dispatch(resetFilters());
        }
      });
    }
  }, [activeBranchId]);

  const handleLimitChange = (e) => {
    dispatch(setPagination({ itemsPerPage: e.target.value, currentPage: 1 }));
  };

  const handlePageChange = (e, value) => {
    dispatch(setCurrentPage(value));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        const formattedData = jsonData.map((item) => ({
          date: parseExcelDateToString(item.date), // Handles serial number, Date object, or string
          typeOfExpense: item.typeOfExpense || '',
          amountPaid: item.amountPaid || 0,
          modeOfPayment: item.modeOfPayment || '',
          recipientName: item.recipientName || '',
          description: item.description || '',
        }));
        setUploadedData(formattedData);
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  const downloadExcelTemplate = () => {
    const headers = [
      "date",
      "typeOfExpense",
      "amountPaid",
      "modeOfPayment",
      "recipientName",
      "description"
    ];

    const sampleData = [
      {
        "date": "YYYY-MM-DD", // Changed to indicate format
        "typeOfExpense": "Groceries",
        "amountPaid": 50.00,
        "modeOfPayment": "Cash",
        "recipientName": "Supermarket",
        "description": "Weekly groceries"
      }
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Expenses");
    XLSX.writeFile(wb, "expense_template.xlsx");
        closeModal();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (uploadedData) {
      setShowLoader(true);
      try {
        const res = await createManyExpense(activeBranchId, { bulkData: uploadedData });
        setShowMessage({
          message: res?.statusCode === 200 ? 'Expenses were successfully uploaded' : 'Expenses failed to upload',
          messageType: res?.statusCode === 200 ? 'success' : 'error',
        });
        getData();
      } catch (error) {
        setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
      } finally {
        setShowLoader(false);
        closeModal();
      }
    }
  };

  const groupedOptions = [
    {
      title: 'Mode of Payment',
      items: filterModeOfPayment,
    },
    {
      title: 'Type of Expense',
      items: expenseTypes.map((type) => ({ label: type.label, value: type.label })),
    },
  ];

  const excelSerialDateToJSDate = (serial) => {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);

    const fractional_day = serial - Math.floor(serial) + 0.0000001;

    let total_seconds = Math.floor(86400 * fractional_day);

    const seconds = total_seconds % 60;
    total_seconds -= seconds;

    const minutes = total_seconds / 60 % 60;
    total_seconds -= minutes * 60;

    const hours = total_seconds / 3600;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  };

  // Formats a JS Date as YYYY-MM-DD using its LOCAL date parts,
  // avoiding the timezone shift that toISOString() (UTC-based) causes.
  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Robustly converts a raw Excel cell value into a 'YYYY-MM-DD' string.
  // Handles three cases that XLSX can hand back depending on how the cell
  // was formatted in the source file:
  //   1. A numeric Excel serial date (e.g. 46248)
  //   2. A JS Date object (when the workbook was read with cellDates:true)
  //   3. A plain string like "18/08/2026", "18-08-2026", or "2026-08-18"
  const parseExcelDateToString = (rawValue) => {
    if (rawValue === undefined || rawValue === null || rawValue === '') {
      return '';
    }

    // Case 1: already a Date object
    if (rawValue instanceof Date && !isNaN(rawValue.getTime())) {
      return formatDateLocal(rawValue);
    }

    // Case 2: numeric Excel serial date
    if (typeof rawValue === 'number' && !isNaN(rawValue)) {
      return formatDateLocal(excelSerialDateToJSDate(rawValue));
    }

    // Case 3: string value
    if (typeof rawValue === 'string') {
      const trimmed = rawValue.trim();

      // If it's actually a numeric string (serial date exported as text)
      if (/^\d+(\.\d+)?$/.test(trimmed)) {
        return formatDateLocal(excelSerialDateToJSDate(Number(trimmed)));
      }

      // ISO format: YYYY-MM-DD or YYYY/MM/DD
      let match = trimmed.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
      if (match) {
        const [, year, month, day] = match;
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      }

      // DD-MM-YYYY or DD/MM/YYYY
      match = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
      if (match) {
        const [, day, month, year] = match;
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      }

      // Fallback: let the Date constructor try, then validate
      const parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) {
        return formatDateLocal(parsed);
      }

      // Could not parse — return empty rather than NaN-NaN-NaN
      return '';
    }

    // Unknown type — return empty rather than NaN-NaN-NaN
    return '';
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setFilters({ search: e.target.value.trimStart() }));
  };

  // Runs when the user pastes into the search box
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();

    // If it looks like a phone number, clean it (remove spaces, dashes, brackets, +91)
    const isPhoneLike = /^[+\d\s\-()]+$/.test(pasted);
    const cleaned = isPhoneLike
      ? pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '')
      : pasted;

    dispatch(setFilters({ search: cleaned }));
  };

  return (
   <PageContainer title="All Expenses" description="This contains all expenses">
  <DashboardCard2 title="All Expenses">
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: '1.7rem',
      }}
    >
      {/* Left Side: Show per page */}
      <div>
        <InputLabel>Show per page</InputLabel>
        <Select
          value={pagination.itemsPerPage}
          onChange={handleLimitChange}
          style={{
            borderRadius: '7px',
            border: '0.5px solid #6174DD',
            padding: '4px 12px',
            background: '#FFF',
            height: '40px',
            width: '100px',
          }}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
           <MenuItem value={1000000}>All</MenuItem>
        </Select>
      </div>

      {/* Right Side: Search and Filter with 0.8rem gap (Search first, then Filter) */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.8rem' }}>
        {/* Search */}
        <div style={{ width: '170px' }}>
          <InputLabel>Search</InputLabel>
          <div className="search-input" style={{ width: '100%', boxSizing: 'border-box' }}>
            <img src={SearchImg} alt="" />
            <input
              placeholder='Search Expenses...'
              value={filters.search}
              onChange={(e) => dispatch(setFilters({ search: e.target.value }))}
              onPaste={handleSearchPaste}
            />
            {filters.search && (
              <IconButton onClick={() => dispatch(setFilters({ search: '' }))}>
                <ClearIcon />
              </IconButton>
            )}
          </div>
        </div>

        {/* Filter */}
        <div style={{ marginTop: '27px' }}>
          <BigFilter
            options={groupedOptions}
            value={filters.filterSelection}
            onChange={(newValues) => dispatch(setFilters({ filterSelection: newValues }))}
            placeholder="Filters"
          />
        </div>

        {/* Bulk Upload - styled to match AllServices "Services Upload" button */}
        {/* <div style={{ marginBottom: '1px' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              background: '#6174DD',
              height: '40px',
              minWidth: '140px',
              '&:hover': {
                background: '#4f5fc7',
              },
            }}
            onClick={openModal}
          >
            Bulk Upload
          </Button>
        </div> */}
        <div style={{ marginBottom: '1px' }}>
          <BulkUploadExpenseDialog onUploaded={getData} />
        </div>
      </div>
    </div>

    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create Many Expenses</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <DialogContent>
          <DialogContentText>
            Upload an Excel file to add multiple expenses at once.
          </DialogContentText>
          <Box p={2}>
            <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
          </Box>
          {uploadedData && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Type of Expense</TableCell>
                    <TableCell>Amount Paid</TableCell>
                    <TableCell>Mode of Payment</TableCell>
                    <TableCell>Recipient Name</TableCell>
                    <TableCell>Description</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {uploadedData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.typeOfExpense}</TableCell>
                      <TableCell>{row.amountPaid}</TableCell>
                      <TableCell>{row.modeOfPayment}</TableCell>
                      <TableCell>{row.recipientName}</TableCell>
                      <TableCell>{row.description}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        {showLoader && <ShowLoader />}
        <DialogActions>
          <Button type="submit" variant="contained" color="primary" disabled={!uploadedData}>
            Submit
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ml: 2 }}
            onClick={downloadExcelTemplate}
          >
            <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
            Sample Download
          </Button>
        </DialogActions>
      </form>
    </Dialog>

    {loading ? (
      <ShowLoader />
    ) : filteredExpenses.length > 0 ? (
      <>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <Expenses data={displayedExpenses} getExpenses={getData} />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="end" marginTop="20px">
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      </>
    ) : (
      <Box>No expenses found.</Box>
    )}
  </DashboardCard2>
</PageContainer>
  );
};

export default AllExpenses;